"use client";

import { useToggleRefinement } from "react-instantsearch";
import { Switch } from "~/components/ui/Switch";
import type { ToggleAttribute } from "~/features/algolia/components/AlgoliaFacetFilters";
import { useCurrency } from "~/lib/hooks/useCentra";
import { LOCALIZED_FILTERS } from "~/lib/utils/isLocalizedBooleanFilter";
import styles from "./ToggleSection.module.css";

export const ToggleSection = ({
	attribute,
	title,
}: {
	attribute: ToggleAttribute;
	title: string;
}) => {
	const { data: currency } = useCurrency();

	const localizedAttribute = LOCALIZED_FILTERS[attribute] ?? attribute;

	const {
		value,
		refine: toggleRefine,
		canRefine: canToggleRefine,
	} = useToggleRefinement({
		attribute: localizedAttribute,
		...(currency ? { on: currency } : {}),
	});

	return (
		<div className={styles.root}>
			<div className={styles.header}>{title}</div>
			<Switch
				checked={value.isRefined}
				title={title}
				disabled={!canToggleRefine}
				onChange={() => toggleRefine(value)}
			/>
		</div>
	);
};
